/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ResolveReferenceRequest} from '@cash-web/protos/squareup/cash/clientsync/service.pb'
import {ResolveReferenceResponse} from '@cash-web/protos/squareup/cash/clientsync/service.pb'


export const resolveReference = (request:ResolveReferenceRequest, options?: CashRequestOptions) => post<ResolveReferenceRequest, ResolveReferenceResponse>("/2.0/cash/resolve-reference", request, {...options, rejectOnError: true })